import React from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { MyDialog } from 'components/MyDialog'
import { Button } from 'components/Button/Button'
import { useModalCloseEvent } from 'components/MyDialog/useModalCloseEvent'

export type MsnSettingsModalUneditableProps = {
  onClose: () => void
}

export const MsnSettingsModalUneditable: React.FC<MsnSettingsModalUneditableProps> = ({ onClose }) => {
  const { t } = useTranslation('editMsnSettings')
  const handleClose = useModalCloseEvent('accountSettings', 'accountsettings_emsnclose_click', onClose)

  return (
    <MyDialog
    heading={t('heading')}
      containerId='medicare-my-acct-msn-settings'
      closeButtonAriaLabel='Close'
      onClose={handleClose}
      >
        <>
          <p className='my-u-pb--8'>{t('subtitle-paragraph')}</p>
          <Alert variation="error" className="my-u-mb--14">
            <p className="ds-c-alert__text">{t('errors.uneditable')}</p>
          </Alert>
          <div className='ds-c-dialog__actions'>
            <div className='ds-l-form-row'>
              <div className='ds-l-col--12 ds-l-sm-col--auto my-u-my--2'>
                <Button type='button' className='ds-c-button ds-c-button--solid my-u-py--6 my-u-width--full' onClick={onClose}>
                  {t('close')}
                </Button>
              </div>
            </div>
          </div>
        </>
      </MyDialog>
  )
}
